import React, { Component } from "react";
import KTWizard from '../../../../theme/_assets/js/wizard';
//import { ProgressBar } from "react-bootstrap";
//import { Table } from "react-bootstrap";
//import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
//import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
//import { Col } from "reactstrap"; //CardImg,
//import AddressMaster from "./../master/AddressMaster";
//import { MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { Breadcrumb } from "react-bootstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import dateFormat from 'dateformat';
import firebase from "firebase/app";
import "firebase/storage";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY
var wizard = null;   

class CreateCorporateCustomer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			"companyName": "", "contactNumber": "", "doorNumber": "", "streetName": "",
			"area": "", "landmark": "", "city": "Chennai", "pincode": "", "email": "", "tankCapacity": "", "dailyNeed": "",
			companyTypes: [], cities: [], companyType: "", roadSize: "", distanceBetweenGateAndSump: "", totalDissolvedSolids: "600-900(Fair)",
			"gstNumber": "", "panNumber": ""[{ "name": "" }], percentage: 0, showModal: false, throwUserError: false,
			"companyNameRequired": false, "contactNumberRequired": false, "doorNumberRequired": false,// "streetNameRequired": false,
			"areaRequired": false, "landmarkRequired": false, "cityRequired": false, "pincodeRequired": false, "email1Required": false, "tankCapacityRequired": false, contactalterRequired : false, "dailyNeedRequired": false, "gstNumberRequired": false, "panNumberRequired": false, "modal": false, userFirstName: "", userLastName: "", userPhoneNumber: "", passLength: false, profileImg: '',contactdocumenturl: '',
			userEmail: "", userPassword: "", userConPassword: "", "pocUserId": "", pocCustomerName: "", pocCustomerId: "",profileImg: '',contactdocumenturl: '', userId: "",alterNumber:"", customerBankId: "", customerBLId: "", customerAddId: "", errors: {
				firstName: '',
				emailId: '',
				password: '',
				gstLength: '',

			},
			lat: 0, lng: 0, disableSubmit: false
		};
		this.submit = this.submit.bind(this)
		this.handleFormFields = this.handleFormFields.bind(this)
		this.onFileChange = this.onFileChange.bind(this);
		this.handleUserFormFields = this.handleUserFormFields.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.documenturlChange= this.documenturlChange.bind(this);
		this.nextStep = this.nextStep.bind(this);
		this.prevStep = this.prevStep.bind(this);
		this.modalToggle = this.modalToggle.bind(this);
		this.userToggle = this.userToggle.bind(this);
		this.KTWizard = React.createRef();
		 this.basicDetailValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
		this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
		this.companyDetailValidator = new SimpleReactValidator({ messages: { currency: "Must be a valid number" }, autoForceUpdate: this, className: 'text-danger' });
		this.addressDetailValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
		this.businessDetailValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
		this.userValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
		this.passwordRef = React.createRef();
	}

	modalToggle = () => {
		this.setState({ showModal: !this.state.showModal });
	}
	onFileChange(e) {
        this.setState({ profileImg: e.target.files[0] })
    }
	toggle = () => {
		let path = "/basic-details";
		this.props.history.push({ pathname: path });
	}

	userToggle() {
		this.setState({
			throwUserError: false,
			modal: !this.state.modal, userFirstName: "", userPhoneNumber: "",
			userEmail: "", userPassword: "", userConPassword: ""
		});
	}
	handleUserFormFields = event => {
		this.userValidator.showMessageFor(event.target.name)
		switch (event.target.id) {
			case "ufirstname":
				this.setState({ userFirstName: event.target.value });
				break;
			case "uphonenumber":
				this.setState({ throwUserError: false, userPhoneNumber: event.target.value });
				break;
			case "uemailId":
				this.setState({ throwUserError: false, userEmail: event.target.value.replace("+","") });
				break;
			case "upassword":
				this.setState({ userPassword: event.target.value });
				break;
			case "uconPassword":
				this.setState({ userConPassword: event.target.value });
				break;
			default:
				break;
		}
	};

	leaveHandle = (event) => {
		event.preventDefault();
		this.validator.showMessageFor(event.target.name)
		const { id, value } = event.target;
		let errors = this.state.errors;

		switch (id) {
			case 'upassword':
				errors.password =
					value.length < 8
						? 'Password must be 8 characters long!'
						: '';
				if (value.length < 8) {
					this.setState({ passLength: true });
				}
				else {
					this.setState({ passLength: false });
				}
				break;
			case 'ugstNumber':
				errors.gstNumber =
					value.length !== 15
						? 'GST Number must be 15 chracters long!'
						: '';
				if (value.length === 15) {
					this.setState({ gstLength: false });
					var str = value;
					var res = str.substring(2, 12);
					this.setState({ panNumber: res })
				}
				else {
					this.setState({ gstLength: true });
				}
				break;
			default:
				break;
		}

		this.setState({ errors, [id]: value }, () => {
			console.log(errors)
		})
	}

	handleChange = event => 
	{
		this.setState({ profileImg: event.target.files[0]}, function () { });
 
	} 
	documenturlChange = event => {
		this.setState({ contactdocumenturl: event.target.files[0]}, function () { });
	}


	handleFormFields = (event) => {
		// this.validator.showMessageFor(event.target.name)
		 this.basicDetailValidator.showMessageFor(event.target.name)
		this.companyDetailValidator.showMessageFor(event.target.name)
		this.businessDetailValidator.showMessageFor(event.target.name)
		this.addressDetailValidator.showMessageFor(event.target.name)
		this.validator.showMessageFor(event.target.name)
		switch (event.target.id) {
			case "ucompanyName":
				this.setState({ "companyName": event.target.value });
				break;
			case "sucompanyName":
				this.setState({ userLastName : event.target.value });
				break;
			case "ucontactNumber":
				this.setState({ "contactNumber": event.target.value });
				this.corporatecontactnumbervalid(event.target.value)
				break;
			case "acontactNumber":
				this.setState({ "alterNumber": event.target.value });
				this.corporatealtervalid(event.target.value)
				break;
			case "udoorNumber":
				this.setState({ "doorNumber": event.target.value });
				break;
			case "ustreetName":
				this.setState({ "streetName": event.target.value });
				break;
			case "uarea":
				this.setState({ "area": event.target.value });
				break;
			case "ulandmark":
				this.setState({ "landmark": event.target.value });
				break;
			case "ucity":
				this.setState({ "city": event.target.value });
				break;
			case "upincode":
				this.setState({ "pincode": event.target.value });
				break;
			case "uemail":
				this.setState({ "email": event.target.value.replace("+","") });
				break;
			case "utankCapacity":
				this.setState({ "tankCapacity": event.target.value });
				break;
			case "udailyNeed":
				this.setState({ "dailyNeed": event.target.value });
				break;
			case "ucompanyType":
				this.setState({ companyType: event.target.value });
				break;
			case "uroadSize":
				this.setState({ roadSize: event.target.value });
				break;
			case "udistanceBetweenGateAndSump":
				this.setState({ distanceBetweenGateAndSump: event.target.value });
				break;
			case "utotalDissolvedSolids":
				this.setState({ totalDissolvedSolids: event.target.value });
				break;
			case "uname":
				this.setState({ "name": event.target.value });
				break;
			case "udesignation":
				this.setState({ "designation": event.target.value });
				break;
			case "uphonenumber":
				this.setState({ "phoneNumber": event.target.value });
				break;
			case "uemail1":
				this.setState({ "email1": event.target.value.replace("+","") });
				break;
			case "uemployeeId":
				this.setState({ "employeeId": event.target.value });
				break;
			case "ugstNumber":
				this.setState({ "gstNumber": event.target.value.toUpperCase() });
				if (event.target.value.length === 15) {
					var str = event.target.value;
					var res = str.substring(2, 12);
					this.setState({ panNumber: res })
				}
				else if(event.target.value.length === 0) {
					this.setState({ panNumber: "" })
				}
				break;
			case "upanNumber":
				this.setState({ "panNumber": event.target.value });
				break;
			case "pCustomerUserId":
				this.setState({ pocCustomerId: event.target.value });
				break;
			default:
				break;
		}
	}
	
	corporatecontactnumbervalid= (data) => {
		if(data != "") {
			if(data.length === 10) {
		
				const postCustData = {  "contactnumber" : data }
		  
		  
			  fetch(process.env.REACT_APP_NODE_ENV + '/api/corpcustomer/corpcontactnumber', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				  .then((data) => {
					 
					//console.log(data.error_token)
					if(data.error_token === 1) {
						this.setState({ contactNumberRequired: '1'})
					}
					else {
							this.setState({ contactNumberRequired: data.error_token })
					}
				   
				  })
				  .catch((err) => console.log(err))
			}
			else if(data.length <= 9) {
				this.setState({ contactNumberRequired: 0 })
			}
			else if(data.length >= 11) {
				this.setState({ contactNumberRequired: 0 })
			}
		  }
		else  {
			this.setState({ contactNumberRequired: 0 })
		}
	  
	  
  }
   corporatealtervalid = (data) =>   {
		if(data != "") {
			if(data.length === 10) {
		
				const postCustData = {  "contactnumber" : data }
		  
		  
			  fetch(process.env.REACT_APP_NODE_ENV + '/api/corpcustomer/corpcontactnumber', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				  .then((data) => {
					 
					//console.log(data.error_token)
					if(data.error_token === 1) {
						this.setState({ contactalterRequired: '1'})
					}
					else {
							this.setState({ contactalterRequired: data.error_token })
					}
				   
				  })
				  .catch((err) => console.log(err))
			}
			else if(data.length <= 9) {
				this.setState({ contactalterRequired: 0 })
			}
			else if(data.length >= 11) {
				this.setState({ contactalterRequired: 0 })
			}
		  }
		else  {
			this.setState({ contactalterRequired: 0 })
		}
	  
	  
  }

	userSubmit = () => {
		if (this.userValidator.allValid()) {
			let postUserData = {
				usercompanyName: this.state.userFirstName, userLastName: this.state.userLastName, userPhoneNumber: this.state.userPhoneNumber,
				userEmail: this.state.userEmail, userPassword: this.state.userPassword, userType: "Corporate Customer"
			};
			postUserData = CryptoJS.AES.encrypt(JSON.stringify(postUserData),key).toString()
			fetch(process.env.REACT_APP_NODE_ENV + '/api/users/createUser', {
				method: 'POST',
				headers: { 
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				},
				body: JSON.stringify({ data: postUserData })
			}).then((response) => {
				if (response.status === 400) {
					this.setState({ throwUserError: true })
				}
				else { return response.json() }
			})
				.then((data) => {
					data = CryptoJS.AES.decrypt(data.userData,key)
					data = JSON.parse(data.toString(CryptoJS.enc.Utf8))
					this.setState({ modal: !this.state.modal, pocCustomerId: data.id, pocCustomerName: data.userEmail })
				})
				.catch((error) => console.log(error))
		} else {
			this.userValidator.showMessages();
			this.forceUpdate();
		}

	}

	validForm() {
		const { companyName, contactNumber, doorNumber, streetName, area, landmark, city, pincode, email,
		} = this.state;
		let validFormFlag = false;
		if (companyName === '') {
			this.setState({ companyNameRequired: true });
			return validFormFlag;
		}

		else if (contactNumber === '') {
			this.setState({ contactNumberRequired: true });
			return validFormFlag;
		}
		else if (doorNumber === '') {
			this.setState({ doorNumberRequired: true });
			return validFormFlag;
		}
		// else if (streetName === '') {
		// 	this.setState({ streetNameRequired: true });
		// 	return validFormFlag;
		// }
		else if (area === '') {
			this.setState({ areaRequired: true });
			return validFormFlag;
		}

		else if (landmark === '') {
			this.setState({ landmarkRequired: true });
			return validFormFlag;
		}
		else if (city === '') {
			this.setState({ cityRequired: true });
			return validFormFlag;
		}
		else if (pincode === '') {
			this.setState({ pincodeRequired: true });
			return validFormFlag;
		}
		else if (email === '') {
			this.setState({ emailRequired: true });
			return validFormFlag;
		}
		else {
			return true;
		}
	}

	componentDidMount() {
		wizard = new KTWizard(this.KTWizard.current, {
			startStep: 1,
			clickableSteps: true
		})

		fetch(process.env.REACT_APP_NODE_ENV + "/api/master/fetchAllCorporateType", {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			}
		})
			.then(res => res.json())
			.then(data => { this.setState({ companyTypes: data }) })
			.catch(error => this.setState({ companyTypes: [] }))

		fetch(process.env.REACT_APP_NODE_ENV + "/api/master/fetchAllCity", {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			}
		})
			.then(res => res.json())
			.then(data => { this.setState({ cities: data }) })
			.catch(error => this.setState({ cities: [] }))
	};

	nextStep() {
		if (wizard.getStep() == 2) {
			if ((this.companyDetailValidator.allValid()) &&  (this.state.contactNumberRequired != 1 || this.state.contactNumberRequired === "" ) ) {
				if (this.state.percentage === 100) return;
				this.setState(prevState => ({ percentage: prevState.percentage + 20 }));

			} else {
				wizard.goPrev();
				toast.error("Please complete the required company detail fields !!!", {
					position: toast.POSITION.TOP_CENTER,

				});
				this.companyDetailValidator.showMessages();
			}
		}
		if ((wizard.getStep() == 4)) {
			if (this.addressDetailValidator.allValid()) {
				if (this.state.percentage === 100) return;
				this.setState(prevState => ({ percentage: prevState.percentage + 20 }));
			} else {
				wizard.goPrev();
				toast.error("Please complete the required address detail fields !!!", {
					position: toast.POSITION.TOP_CENTER,

				});
				this.addressDetailValidator.showMessages();
			}
		}
		if (wizard.getStep() == 3) {
			if (this.businessDetailValidator.allValid()) {
				if (this.state.percentage === 100) return;
				this.setState(prevState => ({ percentage: prevState.percentage + 20 }));
			} else {
				wizard.goPrev();
				toast.error("Please complete the required business detail fields !!!", {
					position: toast.POSITION.TOP_CENTER,

				});
				this.businessDetailValidator.showMessages();
			}
		}
	}

	prevStep() {
		if (this.state.percentage === 100) return;
		this.setState(prevState => ({ percentage: prevState.percentage - 20 }));
	}


	submit = () => {

		if (wizard.getStep() == 4) {


			if (this.companyDetailValidator.allValid() && this.addressDetailValidator.allValid() && this.businessDetailValidator.allValid()) {
				this.setState({ disableSubmit: true });
				
				var assing_profile=""
				if(this.state.profileImg != "" && this.state.contactdocumenturl != "") 
				{
					assing_profile="3"
				}
				else if(this.state.profileImg != "") {
					assing_profile="1"
				}
				else if(this.state.contactdocumenturl != "") {
					assing_profile="2"
				}
				
				if(assing_profile === "3")
				{
					var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.profileImg.name;
					const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.profileImg).then(snapshot => {
						var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.contactdocumenturl.name;
						const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.contactdocumenturl).then(snapshots => {
							const postCustData = {
								"companyName": this.state.userFirstName,"userFirstName": this.state.companyName, "userLastName": this.state.userLastName,  "contactNumber": this.state.contactNumber,
									"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
									"area": this.state.area, "landmark": this.state.landmark,
									"city": this.state.city, "pincode": this.state.pincode,
									"email": this.state.email, "tankCapacity": this.state.tankCapacity, dailyNeed: this.state.dailyNeed,
									companyType: this.state.companyType, roadSize: this.state.roadSize, distanceBetweenGateAndSump: this.state.distanceBetweenGateAndSump,
									totalDissolvedSolids: this.state.totalDissolvedSolids,
									"pocUserId": this.state.pocCustomerId,
									"gstNumber": this.state.gstNumber, "profileimageurl" :  snapshot.metadata.downloadURLs[0]  ,"contractdocumenturl": snapshots.metadata.downloadURLs[0],
									"panNumber": this.state.panNumber, userId: "", customerBankId: "", customerBLId: "", customerAddId: "", "alternateNumber": this.state.alterNumber,
								};
								fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/createCustomer', {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json',
										'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
									},
									body: JSON.stringify(postCustData)
								}).then((res) => res.json())
									.then((data) => {
										if (data !== "") {
											fetch(
												"https://maps.googleapis.com/maps/api/geocode/json?address=" +
												this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
												"&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
											)
												.then(data => data.json())
												.then(resp => {

													const { lat, lng } = resp.results[0].geometry.location;
													this.createAddress(data.corporateId, lat, lng);
													this.setState({ lat: lat, lng: lng })
													toast.success("Profile created successfully!!!", {
														position: toast.POSITION.TOP_CENTER,

													});
												})
												.catch(err => console.log(err));
										}
									})
									.catch((err) => console.log(err))
							
							
							
						})
					})
				}
				else if(assing_profile === "1") {
					var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.profileImg.name;
					const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.profileImg).then(snapshot => {
									const postCustData = {
								"companyName": this.state.userFirstName,"userFirstName": this.state.companyName, "userLastName": this.state.userLastName,  "contactNumber": this.state.contactNumber,
								"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
								"area": this.state.area, "landmark": this.state.landmark,
								"city": this.state.city, "pincode": this.state.pincode,
								"email": this.state.email, "tankCapacity": this.state.tankCapacity, dailyNeed: this.state.dailyNeed,
								companyType: this.state.companyType, roadSize: this.state.roadSize, distanceBetweenGateAndSump: this.state.distanceBetweenGateAndSump,
								totalDissolvedSolids: this.state.totalDissolvedSolids,
								"pocUserId": this.state.pocCustomerId,
								"gstNumber": this.state.gstNumber,
								"panNumber": this.state.panNumber, userId: "", customerBankId: "", customerBLId: "", customerAddId: "", "alternateNumber": this.state.alterNumber, "profileimageurl" :  snapshot.metadata.downloadURLs[0] 
							};
							fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/createCustomer', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
									'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
								},
								body: JSON.stringify(postCustData)
							}).then((res) => res.json())
								.then((data) => {
									if (data !== "") {
										fetch(
											"https://maps.googleapis.com/maps/api/geocode/json?address=" +
											this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
											"&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
										)
											.then(data => data.json())
											.then(resp => {

												const { lat, lng } = resp.results[0].geometry.location;
												this.createAddress(data.corporateId, lat, lng);
												this.setState({ lat: lat, lng: lng })
												toast.success("Profile created successfully!!!", {
													position: toast.POSITION.TOP_CENTER,

												});
											})
											.catch(err => console.log(err));
									}
								})
								.catch((err) => console.log(err))
						
					})
				}
				else if(assing_profile === "2") {
					var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.contactdocumenturl.name;
						const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.contactdocumenturl).then(snapshots => {
							const postCustData = {
								"companyName": this.state.userFirstName,"userFirstName": this.state.companyName, "userLastName": this.state.userLastName,  "contactNumber": this.state.contactNumber,
								"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
								"area": this.state.area, "landmark": this.state.landmark,
								"city": this.state.city, "pincode": this.state.pincode,
								"email": this.state.email, "tankCapacity": this.state.tankCapacity, dailyNeed: this.state.dailyNeed,
								companyType: this.state.companyType, roadSize: this.state.roadSize, distanceBetweenGateAndSump: this.state.distanceBetweenGateAndSump,
								totalDissolvedSolids: this.state.totalDissolvedSolids,
								"pocUserId": this.state.pocCustomerId,
								"gstNumber": this.state.gstNumber,
								"panNumber": this.state.panNumber, userId: "", customerBankId: "", customerBLId: "", customerAddId: "", "alternateNumber": this.state.alterNumber, "contractdocumenturl": snapshots.metadata.downloadURLs[0],
								};
								fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/createCustomer', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
									'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
								},
								body: JSON.stringify(postCustData)
								}).then((res) => res.json())
								.then((data) => {
									if (data !== "") {
										fetch(
											"https://maps.googleapis.com/maps/api/geocode/json?address=" +
											this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
											"&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
										)
											.then(data => data.json())
											.then(resp => {

												const { lat, lng } = resp.results[0].geometry.location;
												this.createAddress(data.corporateId, lat, lng);
												this.setState({ lat: lat, lng: lng })
												toast.success("Profile created successfully!!!", {
													position: toast.POSITION.TOP_CENTER,

												});
											})
											.catch(err => console.log(err));
									}
								})
								.catch((err) => console.log(err))
							
						})
				}
				else {
					
					const postCustData = {
					"companyName": this.state.userFirstName,"userFirstName": this.state.companyName, "userLastName": this.state.userLastName,  "contactNumber": this.state.contactNumber,
					"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
					"area": this.state.area, "landmark": this.state.landmark,
					"city": this.state.city, "pincode": this.state.pincode,
					"email": this.state.email, "tankCapacity": this.state.tankCapacity, dailyNeed: this.state.dailyNeed,
					companyType: this.state.companyType, roadSize: this.state.roadSize, distanceBetweenGateAndSump: this.state.distanceBetweenGateAndSump,
					totalDissolvedSolids: this.state.totalDissolvedSolids,
					"pocUserId": this.state.pocCustomerId,
					"gstNumber": this.state.gstNumber,
					"panNumber": this.state.panNumber, userId: "", customerBankId: "", customerBLId: "", customerAddId: "", "alternateNumber": this.state.alterNumber,
				};
				fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/createCustomer', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					},
					body: JSON.stringify(postCustData)
				}).then((res) => res.json())
					.then((data) => {
						if (data !== "") {
							fetch(
								"https://maps.googleapis.com/maps/api/geocode/json?address=" +
								this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
								"&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
							)
								.then(data => data.json())
								.then(resp => {

									const { lat, lng } = resp.results[0].geometry.location;
									this.createAddress(data.corporateId, lat, lng);
									this.setState({ lat: lat, lng: lng })
									toast.success("Profile created successfully!!!", {
										position: toast.POSITION.TOP_CENTER,

									});
								})
								.catch(err => console.log(err));
						}
					})
					.catch((err) => console.log(err))
					
				}
				
				
				
				
				
					
					
			} else {
				if (!this.businessDetailValidator.allValid()) {
					toast.error("Please complete the required business detail fields !!!", {
						position: toast.POSITION.TOP_CENTER,
					});
					this.businessDetailValidator.showMessages();
					wizard.goTo(3);
				}
				if (!this.addressDetailValidator.allValid()) {
					toast.error("Please complete the required address detail fields !!!", {
						position: toast.POSITION.TOP_CENTER,
					});
					this.addressDetailValidator.showMessages();
					wizard.goTo(2);
				}
				if (!this.companyDetailValidator.allValid()) {
					toast.error("Please complete the required company detail fields !!!", {
						position: toast.POSITION.TOP_CENTER,
					});
					this.companyDetailValidator.showMessages();
					wizard.goTo(1);
				}
				this.forceUpdate();
			}

		};
	}

	createAddress = (corporateId, lattitude, longitude) => {
		let postAddressData = {
			associateId: corporateId, defaultAddress: "Yes",
			fullAddress: this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city, geolocationLat: lattitude, geolocationLng: longitude, label: "Default Shipping Address"
		};
		fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			},
			body: JSON.stringify(postAddressData)
		}).then((response) => response.json())
			.then(data => {
				this.props.history.push({ pathname: "/corp-customer/customer-list" });
			})
	}



	nextPath(path) {
		this.props.history.push(path);
	}

	render() {
		let userError = "";
		if (this.state.throwUserError) {
			userError = (<span style={{ color: "red" }}>Either Email/Phone Number Already Exist</span>)
		}
		let userForm = (
			<form>
				<div className="kt-form__section kt-form__section--first">
					<div className="kt-wizard-v1__form">
						<div className="row">
						     		
								<div className="form-group">
									<label>Company Name *</label>
									<input type="text" className="form-control" ref={this.firstNameRef} required name="User First Name" id="ufirstname" placeholder="Company Name" value={this.state.userFirstName} onChange={this.handleUserFormFields} onBlur={this.leaveHandle} />
									{
										this.userValidator.message('Company Name', this.state.userFirstName, 'required|alpha_space')
									}
									{
										this.state.userFirstNameRequired &&
										<span className="form-text text-muted">Please Company Name.</span>
									}

								</div>			

								{/*<div className="form-group">
									<label>First Name *</label>
									<input type="text" className="form-control" ref={this.firstNameRef} required name="User First Name" id="ufirstname" placeholder="First Name" value={this.state.userFirstName} onChange={this.handleUserFormFields} onBlur={this.leaveHandle} />
									{
										this.userValidator.message('User First Name', this.state.userFirstName, 'required|alpha_space')
									}
									{
										this.state.userFirstNameRequired &&
										<span className="form-text text-muted">Please enter your First Name.</span>
									}

								</div></div>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
				  <div className="col-xs-2">
								<div className="form-group">
									<label>Last Name *</label>
									<input type="text" className="form-control" required name="User Last Name" id="ulastname" placeholder="Last Name" value={this.state.userLastName} onChange={this.handleUserFormFields} />
									{
										this.userValidator.message('User Last Name', this.state.userLastName, 'required|alpha_space')
									}


								</div></div>  */}
								
								
								</div>
						<div className="row">
							<div className="col-xs-2">
								<div className="form-group">
									<label>Phone Number *</label>
									<input type="text" className="form-control" required name="Phone Number" id="uphonenumber" placeholder="Phone Number" value={this.state.userPhoneNumber} onChange={this.handleUserFormFields} />
									{
										this.userValidator.message('Phone Number', this.state.userPhoneNumber, 'required|phone|max:10')
									}
									{
										this.state.userPhoneNumberRequired &&
										<span className="form-text text-muted">Please enter your Phone Number.</span>
									}

								</div></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<div className="col-xs-2">
								<div className="form-group">
									<label>E-mail *</label>
									<input type="text" className="form-control" required name="User Email" id="uemailId" placeholder="E-mail" value={this.state.userEmail} onChange={this.handleUserFormFields} />
									{
										this.userValidator.message('E-mail', this.state.userEmail, 'required|email')
									}
									{
										this.state.userEmailRequired &&
										<span className="form-text text-muted">Please enter your E-mail .</span>
									}

								</div>
							</div></div>
						<div className="row">
							<div className="col-xs-2">
								<div className="form-group">
									<label>Password *</label>
									<input type="password" className="form-control" required ref={this.passwordRef} name="Password" id="upassword" placeholder="Enter Your Password" value={this.state.userPassword} onChange={this.handleUserFormFields} />
									{
										this.userValidator.message('Password', this.state.userPassword, 'required|max:20|min:8')
									}
									{/* {
                  this.state.passLength &&
                  <span className="form-text text-muted"><div style={{ color: 'Red' }}>Password Must Be Minimum 8 characters</div></span>
                } */}
									{/* {
										this.state.userPasswordRequired &&
										<span className="form-text text-muted">Please enter your password.</span>
									} */}
								</div>
							</div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<div className="col-xs-2">
								<div className="form-group">
									<label>Confirm Password *</label>
									<input type="password" className="form-control" required name="Confirm Password" id="uconPassword" placeholder="Confirm Password" value={this.state.userConPassword} onChange={this.handleUserFormFields} />
									{this.userValidator.message('Confirm Password', this.state.userConPassword, `required|in:${this.state.userPassword}`, { messages: { in: 'Passwords need to match!' } })}

									{/* {
										this.state.userConpasswordRequired &&
										<span className="form-text text-muted">Please enter your password.</span>
									} */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		)

		let companyTypeData = this.state.companyTypes.map(data => (
			<option value={data.corporateType}>{data.corporateType}</option>
		))

		let cityData = this.state.cities.map(data => (
			<option value={data.cityName}>{data.cityName}</option>
		))
		return (<>
			<Breadcrumb>
				<Breadcrumb.Item
					onClick={() => this.nextPath("/corp-customer/customer-list")}
				>
					Corporate Customer Details
          </Breadcrumb.Item>

				<Breadcrumb.Item active>Create Corporate Customer</Breadcrumb.Item>
			</Breadcrumb>

			<div>
				<Modal isOpen={this.state.modal} style={{ width: "1000px", display: "block" }}>
					<Card  >
						<Card.Body>
							<ModalHeader>
								Add User
                </ModalHeader>
							<ModalBody>
								{userForm}
								{userError}
							</ModalBody>
							<ModalFooter><div className="col-8 float-center">
								<Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
								&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
							</div>
							</ModalFooter>
						</Card.Body>
					</Card>
				</Modal>
			</div>

			<div>
				{/* <ProgressBar
            animated
            now={this.state.percentage}
            label={`${this.state.percentage}%`}
          /> */}
			</div>

			<div ref={this.KTWizard} className="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1" data-ktwizard-state="step-first">
				<div className="kt-grid__item">
					<div className="kt-wizard-v1__nav">

						<div className="kt-wizard-v1__nav-items kt-wizard-v1__nav-items--clickable">
							<div className="kt-wizard-v1__nav-item" data-ktwizard-type="step" data-ktwizard-state="current">
								<div className="kt-wizard-v1__nav-body">
									<div className="kt-wizard-v1__nav-icon">
										<i className="flaticon2-list-1"></i>
									</div>
									<div className="kt-wizard-v1__nav-label">
										1. Company Details
				</div>
								</div>
							</div>
							<div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
								<div className="kt-wizard-v1__nav-body">
									<div className="kt-wizard-v1__nav-icon">
										<i className="flaticon-interface-10"></i>
									</div>
									<div className="kt-wizard-v1__nav-label">
										2. Business Details
				</div>
								</div>
							</div>

							<div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
								<div className="kt-wizard-v1__nav-body">
									<div className="kt-wizard-v1__nav-icon">
										<i className="flaticon-interface-10"></i>
									</div>
									<div className="kt-wizard-v1__nav-label">
										3. Address Details
				</div>
								</div>
							</div>

							<div className="kt-wizard-v1__nav-item" data-ktwizard-type="step">
								<div className="kt-wizard-v1__nav-body">
									<div className="kt-wizard-v1__nav-icon">
										<i className="flaticon-user-ok"></i>
									</div>
									<div className="kt-wizard-v1__nav-label">
										4. Review and Submit
				</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <!--begin: Form Wizard Form--> */}
				<div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
					{/* <!--begin: Form Wizard Form--> */}
					<form className="kt-form" id="kt_form" >

						{/* <!--begin: Form Wizard Step 1--> */}
						<div className="kt-wizard-v1__content" data-ktwizard-type="step-content" data-ktwizard-state="current">
							<div className="kt-heading kt-heading--md">Basic Details</div>
							<div className="kt-form__section kt-form__section--first">
								<div className="kt-wizard-v1__form">

									<div className="form-group row">
										<div className="col-lg-4">
											<label>First Name  *</label>
											<input type="text" className="form-control" id="ucompanyName" required name="Company Name" placeholder="First Name" value={this.state.companyName} onChange={this.handleFormFields} />
											{
												this.companyDetailValidator.message('First Name', this.state.companyName, 'required')
											}
											
										</div>
										<div className="col-lg-4">
											<label>Last Name  *</label>
											<input type="text" className="form-control" id="sucompanyName" required name="Last Name" placeholder="Last Name" value={this.state.userLastName} onChange={this.handleFormFields} />
											{
												this.companyDetailValidator.message('Last Name', this.state.userLastName, 'required')
											}
											
										</div>

										<div className="col-lg-4">
											<label>Email  *</label>
											<input type="text" className="form-control" name="Email ID" id="uemail" required placeholder="Email" value={this.state.email} onChange={this.handleFormFields} />
											{
												this.companyDetailValidator.message('Email', this.state.email, 'required|email')
											}

											{
												this.state.emailRequired &&
												<span className="form-text text-muted">Please enter your Email.</span>
											}
										</div>

										
										
									</div>	</div>
                                <div className="form-group row">
								
								
									<div className="col-lg-4">
											<label>Contact Number</label>

											<input type="text" className="form-control" name="Contact Number" id="ucontactNumber" required placeholder="Contact Number" value={this.state.contactNumber} onChange={this.handleFormFields} />
											
											
												{(this.state.contactNumberRequired != 0 ?
												<div class="text-danger">Contact Number Already Exists</div> : this.companyDetailValidator.message('Contact Number', this.state.contactNumber, 'phone|max:10') ) }
											
											
										</div>
										<div className="col-lg-4">
											<label>Alternate Number</label>

											<input type="text" className="form-control" name="Alternate Number" id="acontactNumber" required placeholder="Alternate Number" value={this.state.alterNumber} onChange={this.handleFormFields} />
											{(this.state.contactalterRequired != 0 ?
												<div class="text-danger">Contact Number Already Exists</div> : this.companyDetailValidator.message('Alternate Number', this.state.alterNumber, 'phone|max:10') ) }
											

											
											
										</div>
								
									
									<div className="col-lg-2">
											<label>Create Customer *</label>
											<input
												type="text"
												className="form-control"
												name="pcustomerUserId"
												id="pCustomerUserId"
												placeholder="Create Customer"
												value={this.state.pocCustomerName} disabled
												onChange={this.handleFormFields}
											/>
											 {
												this.companyDetailValidator.message('Create Customer', this.state.pocCustomerName, 'required')
											}

											{this.state.customerUserIdRequired && (
												<span className="form-text text-muted">
													Please Create Customer.
											</span>
											)}</div>
										<div className="col-lg-2"> <Button
											variant="outline-success"
											style={{ marginTop: "25px" }}
											onClick={this.userToggle}>
											Add User
												</Button>
												
										</div>
								</div>
								<div className="form-group row">
								  <div className="col-lg-4">
											<label>Profile Picture</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.handleChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
										
						  </div>	
						  
						   <div className="col-lg-4">
											<label>Contract Document</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.documenturlChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
									
						  </div>
								
								</div>
								
								<div className="kt-heading kt-heading--md">Company Details</div>
								<div className="form-group row">
									<div className="col-lg-4">
										<label> Company Type  *</label>
										<select className="form-control" name="Company Type" id="ucompanyType" value={this.state.companyType} onChange={this.handleFormFields}>
											<option value="">Select Company Type</option>
											{companyTypeData}
										</select>
										{
											this.companyDetailValidator.message('Company Type', this.state.companyType, 'required')
										}
									</div>

									<div className="col-lg-4">
										<label>Sump/Tank Capacity (in kl)  *</label>
										<input type="text" className="form-control" name="tankCapacity" id="utankCapacity" placeholder="Sump/Tank Capacity (in kl)" value={this.state.tankCapacity} onChange={this.handleFormFields} />
										{
											this.companyDetailValidator.message('Sump/Tank Capacity', this.state.tankCapacity, 'required|currency')
										}

										{
											this.state.tankCapacityRequired &&
											<span className="form-text text-muted">Please enter your Sump/Tank Capacity.</span>

										}
									</div>

									<div className="col-lg-4">
										<label>Daily Need (in kl)  *</label>
										<input type="text" className="form-control" name="Daily Need" id="udailyNeed" placeholder="Daily Need (in kl)" value={this.state.dailyNeed} onChange={this.handleFormFields} />
										{
											this.companyDetailValidator.message('Daily Need', this.state.dailyNeed, 'required|currency')
										}

										{
											// this.state.tankCapacityRequired &&
											// <span className="form-text text-muted">Please enter your Sump/Tank Capacity.</span>

										}
									</div>
								</div>

								<div className="form-group row">
									
									<div className="col-lg-4">
			
																								   
	   
										<label>Road Size (in ft)</label>
												
										<input name="Road Size" id="uroadSize" placeholder="Road Size (in ft)" className="form-control" value={this.state.roadSize} onChange={this.handleFormFields} />
										{
											this.companyDetailValidator.message('Road Size', this.state.roadSize, 'integer,num')
										}
									</div>
									<div className="col-lg-4">
										<label>Distance Between Gate & Sump (in ft)</label>
										<input name="Distance Between Gate And Sump" id="udistanceBetweenGateAndSump" placeholder="Distance Between Gate & Sump" className="form-control" value={this.state.distanceBetweenGateAndSump} onChange={this.handleFormFields} />
										{
											this.companyDetailValidator.message('Distance Between Gate & Sump', this.state.distanceBetweenGateAndSump, 'integer')
										}
									</div>
									<div className="col-lg-4">
										<label>Preferred TDS  *</label>
										<select className="form-control" name="totalDissolvedSolids" id="utotalDissolvedSolids" value={this.state.totalDissolvedSolids} onChange={this.handleFormFields} >
											<option value="">Select TDS</option>
											<option value="less than 300(Excellent)"> less than 300(Excellent) </option>
											<option value="300-500(Good)"> 300-500(Good) </option> 
											<option value="600-900(Fair)"> 600-900(Fair) </option>
											<option value="900-1200(Poor)"> 900-1200(Poor)</option>
											<option value="Above 1200(Unacceptable)"> Above 1200(Unacceptable)   </option>
										</select>
										{
											this.companyDetailValidator.message('Preferred tds', this.state.totalDissolvedSolids, 'required|string')
										}
									</div>
								</div>
								
							

								
							</div>
						</div>

						{/* <!--end: Form Wizard Step 4--> */}
						{/* <!--begin: Form Wizard Step 5--> */}
						<div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
							<div className="kt-heading kt-heading--md">Business Details</div>
							<div className="kt-form__section kt-form__section--first">
								<div className="kt-wizard-v1__form">


									<div className="kt-wizard-v1__form-label"></div>
									<div className="form-group row">
										<div className="col-lg-4">

											<label>GST Number *</label>

											<input type="text" className="form-control" required ref={this.gstNumberRef} name="gstNumber" id="ugstNumber" placeholder="GST Number" value={this.state.gstNumber} onChange={this.handleFormFields} />
											{
												this.businessDetailValidator.message('gstNumber', this.state.gstNumber, 'required|alpha_num|min:15|max:15')
											}

											{
												this.state.gstLength &&
												<span className="form-text text-muted"><div style={{ color: 'red' }}>GST Number should be 15 characters.</div></span>
											}
										</div>


										<div className="col-lg-4">
											<label>PAN Number *</label>
											<input type="text" className="form-control" name="panNumber" id="upanNumber" disabled placeholder="PAN Number" value={this.state.panNumber} onChange={this.handleFormFields} />
											{
												this.businessDetailValidator.message('panNumber', this.state.panNumber, 'required|alpha_num')
											}

											{
												this.state.panNumberRequired &&
												<span className="form-text text-muted">Please enter your PAN Number.</span>
											}
										</div>
										{/*	<div>
											<label>Contract Document</label>
											<input type="file" className="form-control" id="ddcontract" placeholder="Upload your file" for="ddcontract" ></input>
										</div> */}
									</div>
								</div>
							</div>
						</div>

						{/* <!--end: Form Wizard Step 4--> */}
						{/* <!--begin: Form Wizard Step 5--> */}
						<div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
							<div className="kt-heading kt-heading--md">Address Details</div>
							<div className="kt-form__section kt-form__section--first">
								<div className="kt-wizard-v1__form">
									<div className="kt-wizard-v1__form-label"></div>
									<div className="form-group row">
										<div className="col-lg-4">
											<label>Door Number  *</label>

											<input type="text" className="form-control" name="doorNumber" id="udoorNumber" placeholder="Door Number" value={this.state.doorNumber} onChange={this.handleFormFields} />
											{
												this.addressDetailValidator.message('doorNumber', this.state.doorNumber, 'required')
											}
											{
												this.state.doorNumberRequired &&
												<span className="form-text text-muted">Please enter your Door Number.</span>
											}
										</div>


										<div className="col-lg-4">
											<label>Street Name  *</label>
											<input type="text" className="form-control" name="Street Name" id="ustreetName" required placeholder="Street Name" value={this.state.streetName} onChange={this.handleFormFields} />
											{
												this.addressDetailValidator.message('Street Name', this.state.streetName, 'required')
											}


											{/* {
											this.state.streetNameRequired &&
											<span className="form-text text-muted">Please enter your Street Name.</span>
										} */}
										</div>

										<div className="col-lg-4">
											<label>Area  *</label>
											<input type="text" className="form-control" name="Area" id="uarea" required placeholder="Area" value={this.state.area} onChange={this.handleFormFields} />
											{
												this.addressDetailValidator.message('Area', this.state.area, 'required|regex:^[a-zA-Z-. ]*$')
											}
											{
												this.state.areaRequired &&
												<span className="form-text text-muted">Please enter your Area.</span>
											}
										</div>
									</div>
									<div className="form-group row">
									   <div className="col-lg-4">
											<label>City  *</label>
											<select className="form-control" name="City" id='ucity' value={this.state.city} onChange={this.handleFormFields}>
												<option value=""> Select Your City</option>
												{cityData}
											</select>
											{
												this.addressDetailValidator.message('City', this.state.city, 'required|alpha_space')
											}
											{
												this.state.cityRequired &&
												<span className="form-text text-muted">Please enter your City.</span>
											}
										</div>

										<div className="col-lg-4">
											<label>Landmark  </label>
											<input type="text" className="form-control" name="Landmark" id="ulandmark" required placeholder="Landmark" value={this.state.landmark} onChange={this.handleFormFields} />
											{
												this.addressDetailValidator.message('Landmark', this.state.landmark, 'alpha_space')
											}
											{
												this.state.landmarkRequired &&
												<span className="form-text text-muted">Please enter your Landmark.</span>
											}
										</div>

										
										<div className="col-lg-4">
											<label>Pincode *</label>
											<input type="text" className="form-control" name="pincode" id="upincode" required placeholder="Pincode" value={this.state.pincode} onChange={this.handleFormFields} />
											{
												this.addressDetailValidator.message('pincode', this.state.pincode, 'required|integer|max:6|min:6')
											}

											{
												this.state.pincodeRequired &&
												<span className="form-text text-muted">Please enter your pincode.</span>
											}
										</div>
									</div>


								</div>
							</div>
						</div>




						

						{/* <!--end: Form Wizard Step 5--> */}
						{/* <!--begin: Form Wizard Step 6--> */}
						<div className="kt-wizard-v1__content" data-ktwizard-type="step-content">
							<div className="kt-heading kt-heading--md">Review your Details and Submit</div>
							<div className="kt-form__section kt-form__section--first">
								<div className="kt-wizard-v1__review">
									<div className="row">
										<div className="col-lg-4">
											<div className="kt-wizard-v1__review-item">
												<div className="kt-wizard-v1__review-title">
													Basic Details
																</div>
												<div className="kt-wizard-v1__review-content">
													First Name : {this.state.companyName}<br />
													Last Name : {this.state.userLastName} <br />
													Email : {this.state.email}<br />
													Alternate Number : {this.state.contactNumber}<br />
													Contact Number : {this.state.alterNumber}<br />
													
                                               <div className="kt-wizard-v1__review-title">
													Company Details
																</div>
													
													Company Type: {this.state.companyType}<br />			
													Sump/Tank Capacity (in kl): {this.state.tankCapacity}<br />
													Daily Need : {this.state.dailyNeed}<br />
													Road Size: {this.state.roadSize}<br />
													Distance Between Gate & Sump: {this.state.distanceBetweenGateAndSump}<br />
													Preferred TDS: {this.state.totalDissolvedSolids}<br />
												</div>
											</div></div>
									</div><br />
									<div className="kt-wizard-v1__review-item">
										<div className="kt-wizard-v1__review-title">
											Business Details
																</div>
										<div className="kt-wizard-v1__review-content">
											GST Number : {this.state.gstNumber}<br />
											PAN Number : {this.state.panNumber}<br />
										</div>

									</div><br />
									<div className="row">


										<div className="kt-wizard-v1__review-item">
											<div className="kt-wizard-v1__review-title">
												Address Details
																</div>
											<div className="kt-wizard-v1__review-content">
												Door Number : {this.state.doorNumber}<br />
												Street Name : {this.state.streetName}<br />
												Area : {this.state.area}<br />
												City : {this.state.city}<br />
												Landmark : {this.state.landmark}<br />
												Pincode : {this.state.pincode}<br /></div>

										</div>

									</div>
									
								</div>
							</div>
						</div>

						{/* <!--end: Form Wizard Step 6--> */}

						{/* <!--begin: Form Actions --> */}
						<div className="kt-form__actions">
							<button className="btn btn-secondary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u" data-ktwizard-type="action-prev" onClick={this.prevStep}>
								Previous
													</button>
							<Button
								className="btn btn-success btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
								data-ktwizard-type="action-submit"
								onClick={this.submit} disabled={this.state.disableSubmit}
							>
								{this.state.disableSubmit ? 'Submitting' : 'Submit'}
							</Button>
							<button className="btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u" data-ktwizard-type="action-next" onClick={this.nextStep}>
								Next Step
													</button>
						</div>

						{/* <!--end: Form Actions --> */}
					</form>

					{/* <!--end: Form Wizard Form--> */}
				</div>
			</div>
		</>
		);
	}
}

export default CreateCorporateCustomer;